class BannerSlider {
  constructor(sliderElement) {
    this.slides = sliderElement.querySelectorAll('.banner-slide');
    this.buttons = sliderElement.querySelectorAll('.progress-btn');
    this.index = 0;
    this.duration = 5000;
    this.isAutoRunning = false;

    this.showSlide(this.index);
    this.startAuto();
    this.buttons.forEach((btn, i) => btn.addEventListener('click', () => {
      this.stopAuto();
      this.showSlide(i);
      this.startAuto();
    }));
  }

  showSlide(i) {
    this.slides.forEach((s, n) => s.classList.toggle('active', n === i));
    this.buttons.forEach((b, n) => {
      const bar = b.querySelector('.progress-bar');
      b.classList.toggle('active', n === i);
      bar.style.animation = 'none';
      void bar.offsetWidth; // Trigger reflow
      if (n === i) bar.style.animation = `progressAnim ${this.duration}ms linear forwards`;
    });
    this.index = i;
  }

  nextSlide() {
    this.index = (this.index + 1) % this.slides.length;
    this.showSlide(this.index);
  }

  startAuto() {
    if (!this.isAutoRunning) {
      this.timer = setInterval(() => this.nextSlide(), this.duration);
      this.isAutoRunning = true;
    }
  }

  stopAuto() {
    clearInterval(this.timer);
    this.isAutoRunning = false;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.banner-slider-section').forEach(slider => new BannerSlider(slider));
});
